import React from 'react';

import Thumb from '../img/blogs/react.jpg';

const SomeReactInterviewQuestions = {
    id: 19, permalink: "some-react-interview-questions", thumb: Thumb, postBy: "Wasek Bellah", postDate: "May 14, 2020", categories: "React", title: "Some React Interview Questions", shortDesc: "When you want a Web Developer job, In the Interview you will be faced with ReactJS related questions. So, here are some most Interview Questions about ReactJS.", fullDesc: <>
        <p>When you want a <strong>Web Developer</strong> job, In the <strong>Interview</strong> you will be faced with <strong>ReactJS</strong> related questions. So, here are some most <strong>Interview Questions</strong> about <strong>ReactJS</strong>, that can help you in the <strong>Interview</strong>.</p>


        <h2>When to use a Class Component over a Function Component?</h2>
        <p>If the <strong>component</strong> needs <strong>state or lifecycle</strong> methods then, I will use the <strong>class component</strong> otherwise use <strong>function component</strong>. However, from <strong>React 16.8</strong> with the addition of <strong>Hooks</strong>, we can use <strong>state, lifecycle methods</strong>, and other features in <strong>function components</strong>.</p>


        <h2>What is state in React?</h2>
        <p>The <strong>state of a component</strong> is an <strong>object</strong> that contains some information that may change over the lifetime of the <strong>component</strong>. We should always try to make our <strong>state</strong> as simple as possible and reduce the number of <strong>state components</strong>.</p>


        <h2>What's the difference between state and props in React?</h2>
        <p>In a <strong>React component</strong>, <code>props</code> are <strong>variables</strong> passed to it by its <strong>parent component</strong>. On the other hand, <code>state</code> is also <strong>variables</strong> but directly initialized and managed by the <strong>component</strong>.</p>

        <p>The state can be initialized by props.</p>


        <h2>What are synthetic events in React?</h2>
        <p><code>SyntheticEvent</code> is a <strong>cross-browser</strong> wrapper around the <strong>browser’s</strong> native event. It has the same interface as the <strong>browser’s</strong> native event, including <code>stopPropagation()</code> and <code>preventDefault()</code>, except the events work identically across all <strong>browsers</strong>.</p>


        <h2>What is the use of refs?</h2>
        <p>The <code>refs</code> are used to get the reference to a <strong>DOM(Document Object Model) node</strong> or an instance of a <strong>component</strong> in a <strong>React Application</strong>. However, they can be useful when we need direct access to the <strong>DOM element</strong> or an instance of a <strong>component</strong>.</p>


        <h2>What are React Hooks?</h2>
        <p><strong>React Hooks</strong> let us use state and other <strong>React</strong> features without writing a <strong>class</strong>. This is new addition in <strong>React 16.8</strong>.</p>

        <pre className="code">
            import React, &#123; useState &#125; from "react"; <br /><br />

            const App = () => &#123; <br />
                &nbsp; const [count, setCount] = useState(0); <br />
                &nbsp; return ( <br />
                    &nbsp;   &lt;div className="App"&gt; <br />
                        &nbsp;     &lt;p&gt;You clicked &#123;count&#125; times&lt;&#47;p&gt; <br />
                        &nbsp;     &lt;button onClick=&#123;() => setCount(count + 1)&#125;>Click to add Count&lt;&#47;button&gt; <br />
                    &nbsp;   &lt;&#47;div&gt; <br />
                &nbsp; ); <br />
            &#125;
        </pre>


        <h2>What is the stable release for hooks support?</h2>
        <p><em><strong>React</strong> includes a stable implementation of <strong>React Hooks</strong> for below packages</em>:</p>
        <ul>
            <li>React DOM</li>
            <li>React Native</li>
            <li>React DOM Server</li>
            <li>React Test Renderer</li>
            <li>React Shallow Renderer</li>
        </ul>


        <h2>What are the rules of React Hooks?</h2>
        <p><em>When we use <strong>Hooks</strong> we have to follow two rules</em>:</p>
        <ul>
            <li><strong>Only call Hooks at the top level</strong>. We Shouldn't call <strong>Hooks inside loops, conditions, or nested functions</strong>.</li>
            <li><strong>Only call Hooks from React function components</strong>. We Shouldn't  call <strong>Hooks</strong> from regular <strong>JavaScript functions</strong>.</li>
        </ul>


        <h2>What are the sources used for introducing hooks?</h2>
        <p><em><strong>Hooks</strong> got ideas from several different sources. Some of them are</em>:</p>
        <ul>
            <li>Previous experiments with <strong>functional APIs</strong> in the <strong>react-future repository</strong>.</li>
            <li>Community experiments with render <strong>prop APIs</strong> such as <strong>Reactions Component</strong>.</li>
            <li><strong>State variables</strong> and state cells in <strong>DisplayScript</strong>.</li>
            <li>Subscriptions in Rx.</li>
            <li>Reducer components in <strong>ReasonReact</strong>.</li>
        </ul>


        <h2>What is the purpose of the ESLint plugin for hooks?</h2>
        <p>This <strong>ESLint plugin</strong> enforces the <strong>Rules of Hooks</strong>. It is a part of the <strong>Hooks API for React</strong>.</p>

        <p><em>In particular, the rule enforces that</em>:</p>
        <ul>
            <li>Calls to <strong>Hooks</strong> are either inside a <strong>PascalCase function</strong> (assumed to be a component) or another <code>useSomething</code> function (assumed to be a custom Hook).</li>
            <li><strong>Hooks</strong> are called in the same order on every render.</li>
        </ul>
    </>
};

export default SomeReactInterviewQuestions;